var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaireEquipe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5978 18.8614C30.7304 18.8614 32.4597 17.1333 32.4597 15.0006C32.4597 12.868 30.7304 11.1387 28.5978 11.1387C26.4656 11.1387 24.7363 12.868 24.7363 15.0006C24.7364 17.1333 26.4656 18.8614 28.5978 18.8614Z",
    fill: "#E71873"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5432 22.5829C33.3711 21.5489 32.5164 20.1017 31.8694 19.4552C31.7842 19.3696 31.4033 19.3497 31.3005 19.4135C30.5139 19.8972 29.59 20.182 28.5984 20.182C27.6079 20.182 26.6839 19.8972 25.8973 19.4135C25.794 19.3497 25.4136 19.3696 25.3284 19.4552C25.1475 19.6361 24.9502 19.8768 24.7578 20.156C25.2784 21.1361 25.6912 22.1772 25.8402 23.0737C25.9891 23.9724 25.9407 24.8233 25.6999 25.5989C26.5552 25.9084 27.5809 26.0441 28.5983 26.0441C31.2522 26.0441 33.9681 25.124 33.5432 22.5829Z",
    fill: "#E71873"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6943 17.2326C20.1506 17.2326 22.9528 14.4304 22.9528 10.9742C22.9528 7.51899 20.1506 4.7168 16.6943 4.7168C13.2386 4.7168 10.4375 7.51899 10.4375 10.9742C10.4375 14.4304 13.2386 17.2326 16.6943 17.2326Z",
    fill: "#E71873"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9949 18.191C21.8591 18.0558 21.2424 18.0212 21.0747 18.125C19.7989 18.91 18.3017 19.3695 16.6956 19.3695C15.0906 19.3695 13.5926 18.91 12.3175 18.125C12.1499 18.0212 11.5332 18.0558 11.3974 18.191C10.3464 19.2409 8.96126 21.5879 8.68259 23.2612C7.99549 27.3826 12.3978 28.8705 16.6956 28.8705C20.9945 28.8705 25.3967 27.3826 24.7096 23.2612C24.431 21.5879 23.0458 19.2409 21.9949 18.191Z",
    fill: "#E71873"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.98892 18.8614C7.12107 18.8614 8.85029 17.1333 8.85029 15.0006C8.85029 12.868 7.12107 11.1387 4.98892 11.1387C2.85618 11.1387 1.12695 12.868 1.12695 15.0006C1.12695 17.1333 2.85618 18.8614 4.98892 18.8614Z",
    fill: "#E71873"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55025 23.0737C7.70861 22.1321 8.15542 21.0235 8.71558 19.9983C8.55945 19.7851 8.40339 19.5993 8.25933 19.4552C8.17411 19.3696 7.79376 19.3497 7.69044 19.4135C6.90382 19.8972 5.97984 20.182 4.98888 20.182C3.99779 20.182 3.07322 19.8972 2.28726 19.4135C2.1844 19.3497 1.80299 19.3696 1.71778 19.4552C1.06919 20.1017 0.21671 21.5489 0.0440492 22.5829C-0.380255 25.124 2.33508 26.0441 4.98888 26.0441C5.93596 26.0441 6.89234 25.9275 7.70861 25.661C7.45139 24.8695 7.39694 23.9988 7.55025 23.0737Z",
    fill: "#E71873"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.5874,
    height: 33.5874,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaireEquipe);
export default __webpack_public_path__ + "static/media/faire-equipe.7f846311a1e8750d69c17911878c55e4.svg";
export { ForwardRef as ReactComponent };